// extracted by mini-css-extract-plugin
module.exports = {"ant-layout-sider-trigger":"style_ant-layout-sider-trigger__1jBfU","loader":"style_loader__3W2-5","fullScreen":"style_fullScreen__3_Iti","hidden":"style_hidden__2_j_h"};